import { Grid, Popup, Icon } from "semantic-ui-react";
import { FormCheckbox } from "./Form";
import React from "react";

export const ReviewAccessInput = () => {
  return (
    <>
      <Grid.Row>
        <Grid.Column width={6}>
          <FormCheckbox label="Revisar acessos" name="review_access" fluid />
        </Grid.Column>
      </Grid.Row>
      <Grid.Row style={{ paddingTop: 0 }}>
        <Grid.Column width={16}>
          <span style={{ fontSize: 13, paddingTop: 0 }}>
            Trata-se de uma alteração com mudança de escopo e/ou função do
            trabalho.
          </span>
          <Popup
            position="left center"
            content='Alterações de função, tarefas executadas, escopo de trabalho ou sistemas utilizados que devem acompanhar a revisão de acessos devem estar marcado o box "Revisão de acesso". Em caso de dúvidas, entre em contato com o time responsável pelos acessos.'
            trigger={
              <Icon
                name="info circle"
                size={"small"}
                style={{ verticalAlign: "top" }}
              />
            }
          />
        </Grid.Column>
      </Grid.Row>
    </>
  );
};
